import { type BaseModel } from "@/models/base.model"
import { type ModelConstructorSignature } from "@/models/types/model-constructor-signature"
import { type IBase } from "@/interfaces/api/base.interface"
import { type Ref } from "vue"

export interface IStoreFunctionsConfig<Model> {
  collection?: Ref<Model[]>
  onCreate?: (instance: Model) => void
  onDelete?: (instance: Model) => void
  managed?: boolean
}

export abstract class BaseStoreFunctions<Model extends BaseModel, IData extends IBase> {
  protected modelType
  protected config

  protected constructor(
    modelType: ModelConstructorSignature<IData, Model>,
    config: IStoreFunctionsConfig<Model> = {}
  ) {
    this.modelType = modelType
    this.config = config

    if (this.config.managed === undefined) {
      this.config.managed = true // Managed by default
    }
  }
  public abstract createModel<T extends Model | IData>(model: T): Promise<Model>
  public abstract createModel<T extends (Model | IData)[]>(models: T): Promise<Model[]>
  public abstract createModel(
    modelOrModels: Model | IData | (Model | IData)[]
  ): Promise<Model | Model[]>

  public abstract updateModel(instance: Model | IData): Model

  public abstract deleteModel(instance: Model): boolean

  public getModelType(): ModelConstructorSignature<IData, Model> {
    return this.modelType
  }
}
